"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = _react.default.createElement("svg", {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16"
}, _react.default.createElement("path", {
  d: "M0 .5C0 .22.22 0 .5 0h15c.27 0 .5.22.5.5v2.14a.5.5 0 11-1 0V1H8.5v14h1.64a.5.5 0 010 1H5.86a.5.5 0 110-1H7.5V1H1v1.64a.5.5 0 01-1 0V.5z"
}));

exports.default = _default;